export default __webpack_public_path__ + "static/media/oxetechtrilhas_person.176bf93b.png";